<template>
  <div class="relative">
    <div
      class="w-full h-[50px] desktop:h-[60px] flex items-center justify-center font-secondary"
    >
      <div
        v-if="showBackButton"
        class="absolute left-3 flex items-center cursor-pointer"
        @click="handleBackClick"
      >
        <Icon :size="25" name="ChevronUp" class="stroke-gray-800 -rotate-90" />
        <div class="font-secondary">Back</div>
      </div>

      <a href="/">
        <img
          v-if="origin && origin.id !== 'Dacr'"
          :src="origin.logo.black.url"
          class="h-9 pr-[15px]"
        />
        <DacrWordLogo v-else class="h-[26px] desktop:h-[30px]" />
      </a>

      <div
        v-if="props.showCta"
        class="hidden tablet-v:flex absolute right-[18px] items-center"
      >
        <a
          href="/download"
          class="hidden font-primary font-medium text-[15px] items-center hover:text-green-700 mr-5 cursor-pointer tablet-v:flex"
          target="_blank"
        >
          <div
            class="w-6 h-6 flex items-center justify-center rounded-md border border-gray-400/25 mr-2"
          >
            <Icon name="Dacr" :size="16" />
          </div>
          <div class="font-primary">Get app</div>
        </a>

        <UiButton
          class="min-h-[32px]!"
          primary
          @click="handleCreateAccountClick"
        >
          Create account
        </UiButton>
      </div>
    </div>

    <div
      class="hidden tablet-h:flex w-full absolute top-[calc(100%+10px)] items-center justify-center px-3"
    >
      <Toast />
    </div>

    <div
      v-if="origin && origin.id !== 'Dacr'"
      class="font-secondary text-[14px] leading-[18px] text-gray-800 font-medium flex items-center gap-x-1 w-full justify-center"
    >
      Powered by

      <DacrWordLogo class="h-[15px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import Toast from '@/shared/components/Toast.vue'
import { Icon, UiButton } from '@dacr/ui'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { useOriginStore } from '@/shared/stores/origin'

const props = defineProps<{
  showCta?: boolean
}>()

const route = useRoute()
const router = useRouter()
const originStore = useOriginStore()

const origin = computed(() => originStore.userOrigin)

const showBackButton = computed(() => {
  return route.name === 'ForgotPassword'
})

const handleBackClick = () => {
  router.back()
}

const handleCreateAccountClick = () => {
  if (route.query.email) {
    router.push(`/register?email=${route.query.email}`)
  } else {
    router.push('/register')
  }
}
</script>
